import { Pipe, PipeTransform } from '@angular/core';

import { IAsset, IUserContact } from '@models/types';

@Pipe({
    name: 'userSelect'
})
export class UserSelectPipe implements PipeTransform {

    transform(array: (IAsset & { contact: Partial<IUserContact> })[], queryString: string): (IAsset & { contact: Partial<IUserContact> })[] {
        if (array) {
            if (queryString && !queryString.match(/^\s+$/)) {
                const queryItems = queryString.toLowerCase().trim().split(/\s+/);

                return array.filter((row) => {

                    let matchFound = true;

                    const rowSearchItems = [];
                    if (row.contact) {
                        if (row.contact.first_name) {
                            rowSearchItems.push(row.contact.first_name.toLowerCase());
                        }

                        if (row.contact.last_name) {
                            rowSearchItems.push(row.contact.last_name.toLowerCase());
                        }
                    }

                    if (row.identifiers) {
                        if (row.identifiers.asset_identifier) {
                            rowSearchItems.push(row.identifiers.asset_identifier.toLowerCase());
                        }
                    }

                    for (const queryItem of queryItems) {

                        let exactMatchRequired = false;
                        if (queryItem.startsWith('=')) {
                            exactMatchRequired = true;
                        }

                        let queryItemFound = false;
                        for (const rowSearchItem of rowSearchItems) {
                            if (exactMatchRequired) {
                                const newQueryItem = queryItem.substring(1);

                                if (rowSearchItem === newQueryItem) {
                                    queryItemFound = true;
                                }
                            } else {
                                if (rowSearchItem.indexOf(queryItem) !== -1) {
                                    queryItemFound = true;
                                }
                            }
                            if (queryItemFound) {
                                break;
                            }
                        }

                        if (!queryItemFound) {
                            matchFound = false;
                        }

                    }

                    return matchFound;
                });

            }
        }
        return array;
    }

}
